import React, { useEffect } from 'react';
import { ContentContainer, SectionPage, Row, Col, FormHeader, Button, Heading, HorizontalRule, IconNotificationSuccess, tokens, BrandIconRebatesSavings, BrandIconPayUseCard, BrandIconSupportCare,pxToRem} from '@snsw-gel/react';

import styles from './Confirmation.module.scss';
import { dataLayer } from '../../../services/gtm-dataLayer';

const ConfirmationPage = () => {
    useEffect(() => {
        const currentUrl=window.location.href;
        const pageName=window.location.href.split('/').pop();
        dataLayer(currentUrl,pageName);

        if (window.quickFeed) {
            window.quickFeed.init({
                placeholder: "QuickfeedPlaceholder",
                label: "How was your experience?",
                environment: process.env.REACT_APP_TUTD_ENV,
                sourceApplication: 'seniors-card'
            });
        }
    }, []);

    const isSC = sessionStorage.getItem('CardType') === 'sc';
    const cardText = isSC ? 'Seniors Card' : 'Senior Savers Card';
    const applicationResponse = JSON.parse(sessionStorage.getItem('SeniorsResponse'));
    const wasNumberIssued = !!applicationResponse.issuedSeniorsCardNumber;

    return (
        <>
            <FormHeader title={`Thanks for applying for your ${cardText}`} className={styles['form-header']} />
            <ContentContainer className={styles['content-container']}>
                <Row className={styles['page-row']}>
                    <Col span={12}>
                        <SectionPage className={styles['heading-section']}>
                            <Heading level={2}> <IconNotificationSuccess />We have received your application</Heading>
                        </SectionPage>
                        {
                            wasNumberIssued ? (
                                <>
                                    <SectionPage>
                                        <div className={styles['card-box']}>Your {cardText} number is <span className={styles['card-number']}>{applicationResponse.issuedSeniorsCardNumber}</span></div>
                                    </SectionPage>
                                    <SectionPage>
                                        <Heading level={3}>What happens next?</Heading>
                                        <p>Please take note of your {cardText} number above to start accessing all the benefits and offers available to you as a member. Your physical card will arrive in the mail within 21 business days.</p>
                                    </SectionPage>
                                    <SectionPage>
                                        <Heading level={4}>Add your digital {cardText} to your Service NSW Mobile app</Heading>
                                        <p>To do so, please login to the Service NSW mobile app, and add your digital {cardText} to your licences and credentials.</p>
                                    </SectionPage>
                                </>
                            ) : (
                                <SectionPage>
                                    <h3>What happens next?</h3>
                                    <p>We have received your application and are processing it. Your card will arrive in the mail within 21 business days.</p>
                                </SectionPage>
                            )
                        }
                        <HorizontalRule
                            marginBottom="3.5rem"
                            marginTop="3.5rem"
                        />
                        <SectionPage>
                            <Heading level={3}>Access discounts and special offers{ wasNumberIssued && ' now' }</Heading>
                            {
                                isSC && wasNumberIssued &&
                                OfferBlock(BrandIconPayUseCard, (<>
                                    <Heading level={4} className={styles['offer-heading']}>Apply for a Gold Opal Card</Heading>
                                    <ul style={{ 'margin': 0 }}>
                                        <li>You can now apply for a <a href="https://www.opal.com.au/en/get-an-opal-card/">Gold Opal</a> by using your new Seniors Card number noted above.</li>
                                    </ul>
                                </>))
                            }
                            {
                                OfferBlock(BrandIconRebatesSavings, (<>
                                    <Heading level={4} className={styles['offer-heading']}>See what exclusive discounts are available</Heading>
                                    <ul style={{ 'margin': 0 }}>
                                        <li>Browse the special offers and discounts available from supermarkets, restaurants, utility services and much more via the <a href="https://www.nsw.gov.au/community-services/seniors-card/deals-discounts#discount-map">Online Discounts and Deals map</a></li>
                                    </ul>
                                </>))
                            }
                            {
                                OfferBlock(BrandIconSupportCare, (<>
                                    <Heading level={4} className={styles['offer-heading']}>Book a Cost of Living appointment</Heading>
                                    <ul style={{ 'margin': 0 }}>
                                        <li>If you haven't done so already, find out what <a href="https://www.service.nsw.gov.au/campaign/cost-living">other discounts</a> you might be eligible for.</li>
                                    </ul>
                                </>))
                            }
                            <p>
                                If you have any questions about your application, or how to use your Seniors Card, call us on <a href='tel:137788' style={{fontWeight: 'bold'}}>13 77 88</a>.
                            </p>
                        </SectionPage>
                        <div id="QuickfeedPlaceholder" className={styles.tutd}></div>
                        <SectionPage className={styles['button-panel']}>
                            <Button
                                className={`${styles['button-item']}`}
                                style={{ marginTop: `${pxToRem(tokens.spacing.md)}`, textDecoration: 'none' }}
                                href='https://www.service.nsw.gov.au/transaction/apply-nsw-seniors-card-or-nsw-senior-savers-card'
                            >
                                Home
                            </Button>
                        </SectionPage>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );
};

const OfferBlock = (OfferIcon, content) => (
    <div className={styles['offer-block']}>
        <OfferIcon className={styles['offer-icon']} />
        <span>
            {content}
        </span>
    </div>
);

export default ConfirmationPage;


